{
  "ABRICOT": "Abricot",
  "ACCESSOIRES_DE_FITNESS": "Accessoires de fitness",
  "ADOUCISSANT": "Adoucissant",
  "AGRAFES": "Agrafes",
  "AGRAFEUSE": "Agrafeuse",
  "AIDES_PATISSERIE": "Aides pâtisserie",
  "AIDE_CULINAIRE": "Aide culinaire",
  "AIGUILLETTE_DE_CANARD": "Aiguillette de canard",
  "AIGUILLETTE_DE_POULET": "Aiguillette de poulet",
  "AIL": "Ail",
  "AIL_EN_POUDRE": "Ail en poudre",
  "ALCOOL_MENAGER": "Alcool ménager",
  "ALLUMETTES": "Allumettes",
  "ALLUME_FEU": "Allume-feu",
  "ALTERNATIVES_VEGETALES_AUX_PRODUITS_LAITIERS": "Alternatives végétales aux produits laitiers",
  "AMPOULE": "Ampoule",
  "ANANAS": "Ananas",
  "ANETH_FRAIS": "Aneth frais",
  "ANTIPARASITAIRE": "Antiparasitaire",
  "ANTI_CERNES": "Anti-cernes",
  "ANTI_MOISISSURES": "Anti-moisissures",
  "ANTI_POUX": "Anti-poux",
  "APRES_RASAGE": "Après-rasage",
  "APRES_SHAMPOING": "Après-shampoing",
  "APRES_SOLEIL": "Après-soleil",
  "ARBUSTE": "Arbuste",
  "ARMAGNAC": "Armagnac",
  "ARROSOIR": "Arrosoir",
  "ARTICHAUT_CONSERVE": "Artichaut (conserve)",
  "ARTICLES_DE_CUISINE": "Articles de Cuisine",
  "ASPERGES": "Asperges",
  "ASSAISONNEMENTS_SOUPES": "Assaisonnements & Soupes",
  "ASSIETTE": "Assiette",
  "AUBERGINE": "Aubergine",
  "AUTRES_ANIMAUX": "Autres animaux",
  "AUTRES_BOISSONS_FERMENTEES": "Autres boissons fermentées",
  "AUTRES_FRUITS": "Autres Fruits",
  "AUTRES_NETTOYANTS_MAISON": "Autres nettoyants maison",
  "AUTRE_AIDES_PATISSERIE": "Autre Aides pâtisserie",
  "AUTRE_ALTERNATIVES_VEGETALES_AUX_PRODUITS_LAITIERS": "Autre Alternatives végétales aux produits laitiers",
  "AUTRE_ANIMALERIE": "Autre Animalerie",
  "AUTRE_ARTICLES_DE_CUISINE": "Autre Articles de Cuisine",
  "AUTRE_BASES_MIXES": "Autre Bases & Mixes",
  "AUTRE_BEURRE": "Autre Beurre",
  "AUTRE_BIERES": "Autre Bières",
  "AUTRE_BIERES_ET_CIDRES": "Autre Bières et cidres",
  "AUTRE_BISCUITS_GOUTERS": "Autre Biscuits & Goûters",
  "AUTRE_BOISSONS_CHAUDES": "Autre Boissons chaudes",
  "AUTRE_BOISSONS_SANS_ALCOOL": "Autre Boissons sans alcool",
  "AUTRE_BOUCHERIE": "Autre Boucherie",
  "AUTRE_BOULANGERIE": "Autre Boulangerie",
  "AUTRE_BRICOLAGE_JARDIN_AUTO": "Autre Bricolage, Jardin & Auto",
  "AUTRE_BULBES_ET_AROMATIQUES": "Autre Bulbes et aromatiques",
  "AUTRE_CEREALES_PETIT_DEJEUNER": "Autre Céréales & petit déjeuner",
  "AUTRE_CHAMPAGNES": "Autre Champagnes",
  "AUTRE_CHARCUTERIE": "Autre Charcuterie",
  "AUTRE_CHARCUTERIE_ET_TRAITEUR": "Autre Charcuterie et traiteur",
  "AUTRE_CHAT": "Autre Chat",
  "AUTRE_CHIEN": "Autre Chien",
  "AUTRE_CHOCOLAT_CONFISERIE": "Autre Chocolat & Confiserie",
  "AUTRE_CIDRES": "Autre Cidres",
  "AUTRE_COCKTAILS_ALCOOLISES": "Autre Cocktails alcoolisés",
  "AUTRE_CONSERVES": "Autre Conserves",
  "AUTRE_CREME": "Autre Crème",
  "AUTRE_DESSERTS_LACTES": "Autre Desserts lactés",
  "AUTRE_DIETETIQUE_SPORT": "Autre Diététique & Sport",
  "AUTRE_DROGUERIE_ET_NETTOYAGE": "Autre Droguerie et nettoyage",
  "AUTRE_EAUX": "Autre Eaux",
  "AUTRE_EAUX_DE_VIE_LIQUEURS": "Autre Eaux-de-vie & Liqueurs",
  "AUTRE_ENTRETIEN_DU_LINGE": "Autre Entretien du Linge",
  "AUTRE_EPICERIE_SALEE": "Autre Épicerie salée",
  "AUTRE_EPICERIE_SUCREE": "Autre Épicerie sucrée",
  "AUTRE_EXOTIQUES_ET_AGRUMES": "Autre Exotiques et Agrumes",
  "AUTRE_FECULENTS_CEREALES": "Autre Féculents & Céréales",
  "AUTRE_FLEURS": "Autre Fleurs",
  "AUTRE_FLEURS_COUPEES_BOUQUETS": "Autre Fleurs coupées & bouquets",
  "AUTRE_FROMAGES": "Autre Fromages",
  "AUTRE_FRUITS": "Autre Fruits",
  "AUTRE_FRUITS_A_COQUE": "Autre Fruits à coque",
  "AUTRE_FRUITS_A_PEPINS_OU_A_NOYAUX": "Autre Fruits à pépins ou à noyaux",
  "AUTRE_FRUITS_DE_MER_CRUSTACES": "Autre Fruits de Mer & Crustacés",
  "AUTRE_FRUITS_D_ETE": "Autre Fruits d'été",
  "AUTRE_GINS": "Autre Gins",
  "AUTRE_HYGIENE_ACCESSOIRES": "Autre Hygiène & accessoires",
  "AUTRE_HYGIENE_ET_BEAUTE": "Autre Hygiène et beauté",
  "AUTRE_HYGIENE_QUOTIDIENNE": "Autre Hygiène Quotidienne",
  "AUTRE_JARDINAGE": "Autre Jardinage",
  "AUTRE_JEUX": "Autre Jeux",
  "AUTRE_JEUX_ET_LIVRES": "Autre Jeux et livres",
  "AUTRE_JUS_NECTARS": "Autre Jus & Nectars",
  "AUTRE_LAIT": "Autre Lait",
  "AUTRE_LEGUMES": "Autre Légumes",
  "AUTRE_LEGUMES_FEUILLES": "Autre Légumes feuilles",
  "AUTRE_LEGUMES_FRUITS": "Autre Légumes-Fruits",
  "AUTRE_LEGUMES_RACINES": "Autre Légumes racines",
  "AUTRE_LEGUMES_TIGES_ET_POUSSES": "Autre Légumes tiges et pousses",
  "AUTRE_LINGE_DE_MAISON": "Autre Linge de Maison",
  "AUTRE_LIVRES_PRESSE": "Autre Livres & Presse",
  "AUTRE_MAISON_ET_ENTRETIEN": "Autre Maison et Entretien",
  "AUTRE_MOBILITE": "Autre Mobilité",
  "AUTRE_MUSIQUE_MEDIA": "Autre Musique & Média",
  "AUTRE_OEUFS": "Autre Œufs",
  "AUTRE_PAINS_VIENNOISERIES": "Autre Pains & Viennoiseries",
  "AUTRE_PAPETERIE_SCOLAIRE": "Autre Papeterie & Scolaire",
  "AUTRE_PARFUMERIE_MAQUILLAGE": "Autre Parfumerie & Maquillage",
  "AUTRE_PATISSERIE_TRAITEUR_SEC": "Autre Pâtisserie/Traiteur Sec",
  "AUTRE_PETITS_FRUITS_ET_BAIES": "Autre Petits Fruits et Baies",
  "AUTRE_PLANTES": "Autre Plantes",
  "AUTRE_PLATS_ET_INGREDIENTS_SURGELES": "Autre Plats et Ingrédients Surgelés",
  "AUTRE_POISSON": "Autre Poisson",
  "AUTRE_POISSONS_ET_FRUITS_DE_MER": "Autre Poissons et fruits de mer",
  "AUTRE_PRODUITS_LAITIERS_ET_OEUFS": "Autre Produits laitiers et oeufs",
  "AUTRE_PROTEINES_VEGETALES_BRUTES": "Autre Protéines végétales brutes",
  "AUTRE_RASAGE_EPILATION": "Autre Rasage & Épilation",
  "AUTRE_RHUMS": "Autre Rhums",
  "AUTRE_SAUCES_CONDIMENTS": "Autre Sauces & Condiments",
  "AUTRE_SNACKS_SALES_APERITIF": "Autre Snacks Salés & Apéritif",
  "AUTRE_SODAS_BOISSONS_SPECIALES": "Autre Sodas & Boissons Spéciales",
  "AUTRE_SOIN_CAPILLAIRE": "Autre Soin Capillaire",
  "AUTRE_SOIN_VISAGE_CORPS": "Autre Soin Visage & Corps",
  "AUTRE_SPIRITUEUX": "Autre Spiritueux",
  "AUTRE_SPORT_PLEIN_AIR": "Autre Sport & Plein air",
  "AUTRE_SUBSTITUTS_DE_POISSON": "Autre Substituts de poisson",
  "AUTRE_SUBSTITUTS_DE_VIANDE": "Autre Substituts de viande",
  "AUTRE_SUCRES_TARTINABLES": "Autre Sucres & Tartinables",
  "AUTRE_SURGELES": "Autre Surgelés",
  "AUTRE_TRAITEUR_FRAIS": "Autre Traiteur Frais",
  "AUTRE_TUBERCULES": "Autre Tubercules",
  "AUTRE_VEGETARIEN_ET_VEGAN": "Autre Végétarien et Vegan",
  "AUTRE_VETEMENTS": "Autre Vêtements",
  "AUTRE_VETEMENTS_ET_TISSUS": "Autre Vêtements et tissus",
  "AUTRE_VIANDE": "Autre Viande",
  "AUTRE_VINS": "Autre Vins",
  "AUTRE_VINS_ET_CHAMPAGNES": "Autre Vins et champagnes",
  "AUTRE_VINS_FORTIFIES_APERITIFS": "Autre Vins fortifiés & apéritifs",
  "AUTRE_VODKAS": "Autre Vodkas",
  "AUTRE_VOLAILLE": "Autre Volaille",
  "AUTRE_WHISKIES": "Autre Whiskies",
  "AUTRE_YAOURTS": "Autre Yaourts",
  "AVOCAT": "Avocat",
  "BACON": "Bacon",
  "BAGUETTE": "Baguette",
  "BAIN_DE_BOUCHE": "Bain de bouche",
  "BANANE": "Banane",
  "BANANE_PLANTAIN": "Banane plantain",
  "BANDES_DE_CIRE": "Bandes de cire",
  "BANDE_DESSINEE": "Bande dessinée",
  "BAR": "Bar",
  "BARRES_DE_CEREALES": "Barres de céréales",
  "BARRE_ENERGETIQUE": "Barre énergétique",
  "BARRE_PROTEINEE": "Barre protéinée",
  "BASES_MIXES": "Bases & Mixes",
  "BASILIC_FRAIS": "Basilic frais",
  "BATONNETS_VEGETAUX_TYPE_POISSON": "Bâtonnets végétaux type poisson",
  "BATTERIE": "Batterie",
  "BAUME_APRES_RASAGE": "Baume après-rasage",
  "BAUME_LEVRES": "Baume lèvres",
  "BAVETTE": "Bavette",
  "BETTERAVE": "Betterave",
  "BEURRE": "Beurre",
  "BEURRE_DEMI_SEL": "Beurre demi-sel",
  "BEURRE_DOUX": "Beurre doux",
  "BICARBONATE_ALIMENTAIRE": "Bicarbonate alimentaire",
  "BICARBONATE_DE_SOUDE": "Bicarbonate de soude",
  "BIERE": "Bière",
  "BIERES": "Bières",
  "BIERE_AROMATISEE": "Bière aromatisée",
  "BIERE_SANS_ALCOOL": "Bière sans alcool",
  "BISCOTTE": "Biscotte",
  "BISCUITS": "Biscuits",
  "BISCUITS_APERITIF": "Biscuits apéritif",
  "BISCUITS_FOURRES": "Biscuits fourrés",
  "BISCUITS_GOUTERS": "Biscuits & Goûters",
  "BISCUITS_SECS": "Biscuits secs",
  "BISCUIT_DIETETIQUE": "Biscuit diététique",
  "BLANCHISSANT_LINGE": "Blanchissant linge",
  "BLANC_D_OEUF": "Blanc d'œuf",
  "BLETTES": "Blettes",
  "BLOC_NOTES": "Bloc-notes",
  "BLUSH": "Blush",
  "BOISSONS_CHAUDES": "Boissons chaudes",
  "BOISSON_AUX_FRUITS": "Boisson aux fruits",
  "BOISSON_ENERGISANTE": "Boisson énergisante",
  "BOISSON_GAZEUSE": "Boisson gazeuse",
  "BOISSON_ISOTONIQUE": "Boisson isotonique",
  "BOISSON_LACTEE_AROMATISEE": "Boisson lactée aromatisée",
  "BOISSON_VEGETALE": "Boisson végétale",
  "BOISSON_VEGETALE_AROMATISEE": "Boisson végétale aromatisée",
  "BOITE_DE_CONSERVATION_ALIMENTAIRE": "Boîte de conservation alimentaire",
  "BOL": "Bol",
  "BONBONS": "Bonbons",
  "BOUDIN_BLANC": "Boudin blanc",
  "BOUDIN_NOIR": "Boudin noir",
  "BOUILLON": "Bouillon",
  "BOUILLON_LIQUIDE": "Bouillon liquide",
  "BOULETTES_DE_VIANDE": "Boulettes de viande",
  "BOULETTES_SURGELEES": "Boulettes surgelées",
  "BOULETTE_VEGETALE": "Boulette végétale",
  "BOUQUET_DE_FLEURS": "Bouquet de fleurs",
  "BOUQUET_DE_ROSES": "Bouquet de roses",
  "BOUQUET_GARNI": "Bouquet garni",
  "BOURBON": "Bourbon",
  "BRICOLAGE_JARDIN_AUTO": "Bricolage, Jardin & Auto",
  "BRIOCHE": "Brioche",
  "BRIQUET_DE_CUISINE": "Briquet de cuisine",
  "BROCOLI": "Brocoli",
  "BROSSE": "Brosse",
  "BROSSETTES_INTERDENTAIRES": "Brossettes interdentaires",
  "BROSSE_A_DENTS": "Brosse à dents",
  "BROWNIE": "Brownie",
  "BULBES_DE_FLEURS": "Bulbes de fleurs",
  "BULBES_ET_AROMATIQUES": "Bulbes et aromatiques",
  "BURGER_PRET_A_CONSOMMER": "Burger prêt-à-consommer",
  "BURRATA": "Burrata",
  "BUTTERNUT": "Butternut",
  "CABILLAUD": "Cabillaud",
  "CACAO_EN_POUDRE": "Cacao en poudre",
  "CACHE_POT": "Cache-pot",
  "CACTUS": "Cactus",
  "CAFE": "Café",
  "CAHIER": "Cahier",
  "CAILLE": "Caille",
  "CAISSE_DE_TRANSPORT": "Caisse de transport",
  "CAKE": "Cake",
  "CALAMAR": "Calamar",
  "CAMPING": "Camping",
  "CARAMELS": "Caramels",
  "CAROTTE": "Carotte",
  "CASSEROLE": "Casserole",
  "CASSIS": "Cassis",
  "CASSONADE": "Cassonade",
  "CELERI_RAVE": "Céleri-rave",
  "CEREALES_A_CUISINER_GRAINES": "Céréales à cuisiner & Graines",
  "CEREALES_PETIT_DEJEUNER": "Céréales petit déjeuner",
  "CERISE": "Cerise",
  "CHAMPAGNE": "Champagne",
  "CHAMPAGNES": "Champagnes",
  "CHAMPAGNE_ROSE": "Champagne rosé",
  "CHAMPIGNON_CONSERVE": "Champignon (conserve)",
  "CHAMPIGNON_FRAIS": "Champignon (frais)",
  "CHARCUTERIE": "Charcuterie",
  "CHAT": "Chat",
  "CHATAIGNE": "Châtaigne",
  "CHAUSSETTE": "Chaussette",
  "CHAUSSON_AUX_POMMES": "Chausson aux pommes",
  "CHEMISE": "Chemise",
  "CHEVRE": "Chèvre",
  "CHEWING_GUM": "Chewing-gum",
  "CHIEN": "Chien",
  "CHIFFON_MICROFIBRE": "Chiffon microfibre",
  "CHIPOLATA": "Chipolata",
  "CHIPS": "Chips",
  "CHOCOLAT": "Chocolat",
  "CHOCOLAT_CONFISERIE": "Chocolat & Confiserie",
  "CHOCOLAT_DE_PATISSERIE": "Chocolat de pâtisserie",
  "CHOCOLAT_EN_POUDRE": "Chocolat en poudre",
  "CHORIZO": "Chorizo",
  "CHOU": "Chou",
  "CHOU_DE_BRUXELLES": "Chou de Bruxelles",
  "CHOU_FLEUR": "Chou-fleur",
  "CHOU_KALE": "Chou kale",
  "CHRYSANTHEMES": "Chrysanthèmes",
  "CIBOULETTE": "Ciboulette",
  "CIDRE": "Cidre",
  "CIDRES": "Cidres",
  "CIDRE_SANS_ALCOOL": "Cidre sans alcool",
  "CIRE_DEPILATOIRE": "Cire dépilatoire",
  "CIRE_POUR_MEUBLES": "Cire pour meubles",
  "CISEAUX": "Ciseaux",
  "CITRON": "Citron",
  "CITRONNELLE": "Citronnelle",
  "CLASSEUR_ANNEAUX": "Classeur anneaux",
  "CLEMENTINE": "Clémentine",
  "CLOU": "Clou",
  "COCKTAILS_ALCOOLISES": "Cocktails alcoolisés",
  "COCKTAIL_PRET_A_BOIRE": "Cocktail prêt-à-boire",
  "COGNAC": "Cognac",
  "COING": "Coing",
  "COLIN": "Colin",
  "COLLANT": "Collant",
  "COLLE": "Colle",
  "COLLIER": "Collier",
  "COLORATION_CHEVEUX": "Coloration cheveux",
  "COMPLEMENT_ALIMENTAIRE": "Complément alimentaire",
  "COMPOTE": "Compote",
  "COMPRESSE": "Compresse",
  "CONCOMBRE": "Concombre",
  "CONFITURE": "Confiture",
  "CONFIT_DE_FRUITS_ET_FLEURS": "Confit de fruits et fleurs",
  "CONSERVES": "Conserves",
  "CONSERVES_DE_FRUITS_DE_MER": "Conserves de fruits de mer",
  "CONSERVES_DE_LEGUMES": "Conserves de légumes",
  "CONSERVES_DE_LEGUMINEUSES": "Conserves de légumineuses",
  "CONSERVES_DE_PLATS_CUISINES": "Conserves de plats cuisinés",
  "CONSERVES_DE_POISSON": "Conserves de poisson",
  "CONSERVES_DE_TOMATES": "Conserves de tomates",
  "CONTOUR_DES_YEUX": "Contour des yeux",
  "COOKIES": "Cookies",
  "COQUES": "Coques",
  "CORDON_BLEU": "Cordon bleu",
  "CORIANDRE_FRAICHE": "Coriandre fraîche",
  "CORNICHONS": "Cornichons",
  "CORNICHON_FRAIS": "Cornichon frais",
  "COTELETTE_D_AGNEAU": "Côtelette d’agneau",
  "COTE_DE_BOEUF": "Côte de bœuf",
  "COTE_DE_PORC": "Côte de porc",
  "COTE_DE_VEAU": "Côte de veau",
  "COTONS_TIGES": "Cotons-tiges",
  "COTON_DEMAQUILLANT": "Coton démaquillant",
  "COUETTE": "Couette",
  "COURGE": "Courge",
  "COURGETTE": "Courgette",
  "COUSCOUS_SURGELE": "Couscous surgelé",
  "COUTEAU": "Couteau",
  "COUVERTURE": "Couverture",
  "CRABE": "Crabe",
  "CRACKERS": "Crackers",
  "CRAYON": "Crayon",
  "CREME": "Crème",
  "CREME_CORPS": "Crème corps",
  "CREME_DEPILATOIRE": "Crème dépilatoire",
  "CREME_DESSERT": "Crème dessert",
  "CREME_EPAISSE": "Crème épaisse",
  "CREME_FOUETTEE": "Crème fouettée",
  "CREME_FRAICHE": "Crème fraîche",
  "CREME_GLACEE": "Crème glacée",
  "CREME_LIQUIDE": "Crème liquide",
  "CREME_MAINS": "Crème mains",
  "CREME_PATISSIERE": "Crème pâtissière",
  "CREME_VEGETALE": "Crème végétale",
  "CREME_VISAGE": "Crème visage",
  "CREPES": "Crêpes",
  "CREPE_SALEE": "Crêpe salée",
  "CREVETTES": "Crevettes",
  "CRISTAUX_DE_SOUDE": "Cristaux de soude",
  "CROISSANT": "Croissant",
  "CROQUETTES": "Croquettes",
  "CROQUETTES_CHAT": "Croquettes chat",
  "CROQUETTES_CHIEN": "Croquettes chien",
  "CROUTONS": "Croutons",
  "CUILLERE": "Cuillère",
  "CUISSE_DE_CANARD": "Cuisse de canard",
  "CUISSE_DE_POULET": "Cuisse de poulet",
  "CURCUMA_FRAIS": "Curcuma frais",
  "DEBOUCHEUR_DE_CANALISATIONS": "Déboucheur de canalisations",
  "DECORATION": "Décoration",
  "DECOR_PATISSERIE": "Décor pâtisserie",
  "DEMAQUILLANT": "Démaquillant",
  "DENTIFRICE": "Dentifrice",
  "DEODORANT": "Déodorant",
  "DESODORISANT_INTERIEUR": "Désodorisant intérieur",
  "DESODORISANT_TEXTILE": "Désodorisant textile",
  "DESSERTS_LACTES": "Desserts lactés",
  "DESSERT_LACTE": "Dessert lacté",
  "DESSERT_VEGETAL": "Dessert végétal",
  "DETACHANT": "Détachant",
  "DETARTRANT": "Détartrant",
  "DIETETIQUE_SPORT": "Diététique & Sport",
  "DIFFUSEUR": "Diffuseur",
  "DISSOLVANT": "Dissolvant",
  "DORADE": "Dorade",
  "DRAP_HOUSSE": "Drap-housse",
  "DROGUERIE_ET_NETTOYAGE": "Droguerie et nettoyage",
  "EAU": "Eau",
  "EAUX": "Eaux",
  "EAUX_DE_VIE_LIQUEURS": "Eaux-de-vie & Liqueurs",
  "EAU_AROMATISEE": "Eau aromatisée",
  "EAU_DE_PARFUM": "Eau de parfum",
  "EAU_DE_SOURCE": "Eau de source",
  "EAU_DE_TOILETTE": "Eau de toilette",
  "EAU_DE_VIE": "Eau-de-vie",
  "EAU_GAZEUSE": "Eau gazeuse",
  "EAU_MICELLAIRE": "Eau micellaire",
  "EAU_MINERALE": "Eau minérale",
  "ECHALOTE": "Échalote",
  "ECHINE_DE_PORC": "Échine de porc",
  "EDULCORANT": "Édulcorant",
  "EMINCE_VEGETAL": "Émincé végétal",
  "ENDIVE": "Endive",
  "ENGRAIS": "Engrais",
  "ENGRAIS_PLANTES_FLEURIES": "Engrais plantes fleuries",
  "ENTRECOTE": "Entrecôte",
  "ENTRETIEN_DU_LINGE": "Entretien du Linge",
  "ENVELOPPE": "Enveloppe",
  "EPAULE_D_AGNEAU": "Épaule d’agneau",
  "EPINARD": "Épinard",
  "EPONGE": "Eponge",
  "ESCALOPE_DE_DINDE": "Escalope de dinde",
  "ESCALOPE_DE_VEAU": "Escalope de veau",
  "ESCALOPE_VEGETALE": "Escalope végétale",
  "ESTRAGON_FRAIS": "Estragon frais",
  "EXOTIQUES_ET_AGRUMES": "Exotiques et Agrumes",
  "EYE_LINER": "Eye-liner",
  "FALAFEL": "Falafel",
  "FARD_A_PAUPIERES": "Fard à paupières",
  "FARINE": "Farine",
  "FAUX_FILET": "Faux-filet",
  "FECULENTS_CEREALES": "Féculents & Céréales",
  "FETA": "Feta",
  "FEUILLES": "Feuilles",
  "FEUILLES_DE_COMBAVA": "Feuilles de combava",
  "FEUTRE": "Feutre",
  "FILET_DE_BOEUF": "Filet de bœuf",
  "FILET_DE_DINDE": "Filet de dinde",
  "FILET_DE_POULET": "Filet de poulet",
  "FILET_MIGNON_DE_PORC": "Filet mignon de porc",
  "FILET_VEGETAL_TYPE_POISSON": "Filet végétal type poisson",
  "FILM_ALIMENTAIRE": "Film alimentaire",
  "FILTRES_A_CAFE_PAPIER": "Filtres à café papier",
  "FIL_DENTAIRE": "Fil dentaire",
  "FLACON_VIDE_RECHARGEABLE": "Flacon vide rechargeable",
  "FLAGEOLET": "Flageolet",
  "FLAN": "Flan",
  "FLEURS_COMESTIBLES": "Fleurs comestibles",
  "FLEURS_COUPEES_BOUQUETS": "Fleurs coupées & bouquets",
  "FLEURS_SECHEES": "Fleurs séchées",
  "FOIE_GRAS": "Foie gras",
  "FOIN": "Foin",
  "FOND_DE_TEINT": "Fond de teint",
  "FOURCHETTE": "Fourchette",
  "FRAISE": "Fraise",
  "FRAMBOISE": "Framboise",
  "FRIANDISE_CHAT": "Friandise chat",
  "FRIANDISE_CHIEN": "Friandise chien",
  "FRITES_SURGELEES": "Frites surgelées",
  "FROMAGES": "Fromages",
  "FROMAGE_A_PATE_MOLLE": "Fromage à pâte molle",
  "FROMAGE_A_PATE_PERSILLEE": "Fromage à pâte persillée",
  "FROMAGE_A_PATE_PRESSEE": "Fromage à pâte pressée",
  "FROMAGE_FONDU": "Fromage fondu",
  "FROMAGE_FRAIS": "Fromage frais",
  "FROMAGE_RAPE": "Fromage râpé",
  "FROMAGE_VEGETAL": "Fromage végétal",
  "FRUITS_A_COQUE": "Fruits à coque",
  "FRUITS_A_PEPINS_OU_A_NOYAUX": "Fruits à pépins ou à noyaux",
  "FRUITS_DE_MER_CRUSTACES": "Fruits de Mer & Crustacés",
  "FRUITS_DE_MER_SURGELES": "Fruits de mer surgelés",
  "FRUITS_D_ETE": "Fruits d'été",
  "FRUITS_SECS_SALES": "Fruits secs salés",
  "FRUITS_SURGELES": "Fruits surgelés",
  "FRUIT_DE_LA_PASSION": "Fruit de la passion",
  "GALETTE": "Galette",
  "GALETTE_DE_CEREALES": "Galette de céréales",
  "GAMELLE": "Gamelle",
  "GANTS_DE_JARDINAGE": "Gants de jardinage",
  "GANTS_DE_TRAVAIL": "Gants de travail",
  "GATEAUX_MOELLEUX_INDIVIDUELS": "Gâteaux moelleux individuels",
  "GAUFRETTES": "Gaufrettes",
  "GELEE": "Gelée",
  "GEL_A_RASER": "Gel à raser",
  "GEL_DE_SOIN": "Gel de soin",
  "GEL_DOUCHE": "Gel douche",
  "GEL_ENERGETIQUE": "Gel énergétique",
  "GEL_HYDROALCOOLIQUE": "Gel hydroalcoolique",
  "GEL_NETTOYANT_VISAGE": "Gel nettoyant visage",
  "GERBERAS": "Gerberas",
  "GIGOT_D_AGNEAU": "Gigot d’agneau",
  "GIN": "Gin",
  "GINGEMBRE_FRAIS": "Gingembre frais",
  "GINGEMBRE_MARINE": "Gingembre mariné",
  "GINS": "Gins",
  "GLACE": "Glace",
  "GOMMAGE_VISAGE": "Gommage visage",
  "GOMME": "Gomme",
  "GRAINES": "Graines",
  "GRAINES_ALIMENTAIRES_SUCREES": "Graines alimentaires sucrées",
  "GRANOLA": "Granola",
  "GRATIN_FRAIS": "Gratin frais",
  "GRESSINS": "Gressins",
  "GROSEILLE": "Groseille",
  "GUACAMOLE": "Guacamole",
  "GUIMAUVES": "Guimauves",
  "HACHE_VEGETAL": "Haché végétal",
  "HACHIS_PARMENTIER_FRAIS": "Hachis Parmentier frais",
  "HARICOT_SEC": "Haricot sec",
  "HARISSA": "Harissa",
  "HARNAIS": "Harnais",
  "HAUT_DE_CUISSE_DE_POULET": "Haut de cuisse de poulet",
  "HERBES_DE_PROVENCE": "Herbes de Provence",
  "HOMARD": "Homard",
  "HOUMOUS": "Houmous",
  "HOUMOUS_VEGETAL": "Houmous végétal",
  "HOUSSE_DE_COUETTE": "Housse de couette",
  "HUILE": "Huile",
  "HUILE_CAPILLAIRE": "Huile capillaire",
  "HUILE_D_OLIVE": "Huile d'olive",
  "HUILE_ESSENTIELLE": "Huile essentielle",
  "HUILE_MOTEUR": "Huile moteur",
  "HUITRES": "Huîtres",
  "HYDROMEL": "Hydromel",
  "HYGIENE_ACCESSOIRES": "Hygiène & accessoires",
  "HYGIENE_QUOTIDIENNE": "Hygiène Quotidienne",
  "IGNAME": "Igname",
  "INFUSION": "Infusion",
  "INSECTICIDE": "Insecticide",
  "JAMBON_CRU": "Jambon cru",
  "JAMBON_CUIT": "Jambon cuit",
  "JARDINAGE": "Jardinage",
  "JARRET_DE_BOEUF": "Jarret de bœuf",
  "JARRET_DE_VEAU": "Jarret de veau",
  "JAVEL": "Javel",
  "JEAN": "Jean",
  "JEUX": "Jeux",
  "JEUX_DE_SOCIETE": "Jeux de société",
  "JEU_DE_CARTES": "Jeu de cartes",
  "JOUET_POUR_ANIMAL": "Jouet pour animal",
  "JOURNAL": "Journal",
  "JUPE": "Jupe",
  "JUS_DE_CITRON_CONDIMENT": "Jus de citron condiment",
  "JUS_DE_FRUITS": "Jus de fruits",
  "JUS_DE_LEGUMES": "Jus de légumes",
  "JUS_NECTARS": "Jus & Nectars",
  "KEFIR": "Kéfir",
  "KETCHUP": "Ketchup",
  "KIWI": "Kiwi",
  "KOMBUCHA": "Kombucha",
  "LAISSE": "Laisse",
  "LAIT": "Lait",
  "LAIT_AROMATISE": "Lait aromatisé",
  "LAIT_CONCENTRE": "Lait concentré",
  "LAIT_CORPOREL": "Lait corporel",
  "LAIT_FERMENTE": "Lait fermenté",
  "LAMES_DE_RASOIR": "Lames de rasoir",
  "LANGOUSTINE": "Langoustine",
  "LAPIN": "Lapin",
  "LARDONS": "Lardons",
  "LASAGNES_FRAICHES": "Lasagnes fraîches",
  "LASAGNES_SURGELEES": "Lasagnes surgelées",
  "LAURIER": "Laurier",
  "LAURIER_FRAIS": "Laurier frais",
  "LAVETTE": "Lavette",
  "LAVE_GLACE": "Lave-glace",
  "LEGUMES_CUISINES_SURGELES": "Légumes cuisinés surgelés",
  "LEGUMES_FEUILLES": "Légumes feuilles",
  "LEGUMES_FRUITS": "Légumes-Fruits",
  "LEGUMES_NATURE_SURGELES": "Légumes nature surgelés",
  "LEGUMES_RACINES": "Légumes racines",
  "LEGUMES_TIGES_ET_POUSSES": "Légumes tiges et pousses",
  "LENTILLES": "Lentilles",
  "LESSIVE": "Lessive",
  "LESSIVE_CAPSULES": "Lessive capsules",
  "LESSIVE_POUDRE": "Lessive poudre",
  "LEVURE_BOULANGERE": "Levure boulangère",
  "LEVURE_CHIMIQUE": "Levure chimique",
  "LIEU": "Lieu",
  "LIMONADE": "Limonade",
  "LINGETTES_HYGIENIQUES": "Lingettes hygiéniques",
  "LINGE_DE_BAIN": "Linge de bain",
  "LINGE_DE_LIT": "Linge de lit",
  "LINGE_DE_MAISON": "Linge de Maison",
  "LINGE_DE_TABLE": "Linge de table",
  "LIQUEUR": "Liqueur",
  "LIQUIDE_DE_RINCAGE": "Liquide de rinçage",
  "LIQUIDE_VAISSELLE": "Liquide vaisselle",
  "LITIERE": "Litière",
  "LITIERE_RONGEURS": "Litière rongeurs",
  "LIVRE": "Livre",
  "LIVRES_PRESSE": "Livres & Presse",
  "LYS": "Lys",
  "MACHE": "Mâche",
  "MADELEINES": "Madeleines",
  "MAGAZINE": "Magazine",
  "MAGRET_DE_CANARD": "Magret de canard",
  "MAILLOT_DE_BAIN": "Maillot de bain",
  "MANDARINE": "Mandarine",
  "MANGUE": "Mangue",
  "MANIOC": "Manioc",
  "MANTEAU": "Manteau",
  "MAQUEREAU": "Maquereau",
  "MAQUILLAGE": "Maquillage",
  "MARGARINE": "Margarine",
  "MARMELADE": "Marmelade",
  "MASCARA": "Mascara",
  "MASQUE_CAPILLAIRE": "Masque capillaire",
  "MASQUE_VISAGE": "Masque visage",
  "MATERIEL_DE_FITNESS": "Matériel de fitness",
  "MAYONNAISE": "Mayonnaise",
  "MELON": "Melon",
  "MENTHE_FRAICHE": "Menthe fraîche",
  "MERGUEZ": "Merguez",
  "MERLU": "Merlu",
  "METRE_RUBAN": "Mètre ruban",
  "MIEL": "Miel",
  "MIRABELLE": "Mirabelle",
  "MOBILIER_DE_JARDIN": "Mobilier de jardin",
  "MOBILITE": "Mobilité",
  "MOCKTAIL": "Mocktail",
  "MORTADELLE": "Mortadelle",
  "MOULES": "Moules",
  "MOULE_PATISSERIE": "Moule pâtisserie",
  "MOUSSE_AU_CHOCOLAT": "Mousse au chocolat",
  "MOUSSE_A_RASER": "Mousse à raser",
  "MOUTARDE": "Moutarde",
  "MOZZARELLA": "Mozzarella",
  "MUESLI": "Muesli",
  "MUFFIN": "Muffin",
  "MUG": "Mug",
  "MURE": "Mûre",
  "MUSCAT": "Muscat",
  "MUSIQUE_CD_VINYLE": "Musique (CD/Vinyle)",
  "MUSIQUE_MEDIA": "Musique & Média",
  "MYRTILLE": "Myrtille",
  "NAPPE": "Nappe",
  "NAVET": "Navet",
  "NECTAR": "Nectar",
  "NECTARINE": "Nectarine",
  "NETTOYANT_MULTI_USAGE": "Nettoyant multi-usage",
  "NOISETTE": "Noisette",
  "NOIX": "Noix",
  "NOUGAT": "Nougat",
  "NOUILLES_ASIATIQUES": "Nouilles asiatiques",
  "NOURRITURE_OISEAUX": "Nourriture oiseaux",
  "NOURRITURE_POISSONS": "Nourriture poissons",
  "NOURRITURE_RONGEURS": "Nourriture rongeurs",
  "NUGGETS_DE_POULET": "Nuggets de poulet",
  "NUGGETS_VEGETAUX": "Nuggets végétaux",
  "OEILLETS": "Œillets",
  "OEUFS": "Œufs",
  "OEUFS_LIQUIDES": "Œufs liquides",
  "OIGNON": "Oignon",
  "OLIVES": "Olives",
  "ORANGE": "Orange",
  "ORCHIDEE": "Orchidée",
  "OREILLER": "Oreiller",
  "OUTIL": "Outil",
  "PAELLA_SURGELEE": "Paella surgelée",
  "PAIN": "Pain",
  "PAINS_VIENNOISERIES": "Pains & Viennoiseries",
  "PAIN_AU_CHOCOLAT": "Pain au chocolat",
  "PAIN_DE_MIE": "Pain de mie",
  "PAIN_D_EPICES": "Pain d’épices",
  "PAIN_HAMBURGER": "Pain hamburger",
  "PAIN_HOT_DOG": "Pain hot-dog",
  "PAIN_PITA": "Pain pita",
  "PALOURDES": "Palourdes",
  "PAMPLEMOUSSE": "Pamplemousse",
  "PANACHE": "Panaché",
  "PANAIS": "Panais",
  "PANTALON": "Pantalon",
  "PAPAYE": "Papaye",
  "PAPETERIE_SCOLAIRE": "Papeterie & Scolaire",
  "PAPIER_ALUMINIUM": "Papier aluminium",
  "PAPIER_CUISSON": "Papier cuisson",
  "PARFUM": "Parfum",
  "PARFUMERIE_MAQUILLAGE": "Parfumerie & Maquillage",
  "PARFUM_D_AMBIANCE": "Parfum d'ambiance",
  "PASTEQUE": "Pastèque",
  "PATATE_DOUCE": "Patate douce",
  "PATE": "Pâté",
  "PATEE_CHAT": "Pâtée chat",
  "PATEE_CHIEN": "Pâtée chien",
  "PATES": "Pâtes",
  "PATES_FRAICHES": "Pâtes fraîches",
  "PATE_A_PIZZA": "Pâte à pizza",
  "PATE_A_TARTE": "Pâte à tarte",
  "PATE_A_TARTINER": "Pâte à tartiner",
  "PATE_BRISEE": "Pâte brisée",
  "PATE_DE_CURRY": "Pâte de curry",
  "PATE_D_AMANDE": "Pâte d’amande",
  "PATE_EN_CROUTE": "Pâté en croûte",
  "PATE_ET_TERRINE_EN_CONSERVE": "Pâté et terrine en conserve",
  "PATE_FEUILLETEE": "Pâte feuilletée",
  "PATE_SABLEE": "Pâte sablée",
  "PATISSERIE_SURGELEE": "Pâtisserie surgelée",
  "PATISSERIE_TRAITEUR_SEC": "Pâtisserie/Traiteur Sec",
  "PECHE": "Pêche",
  "PEIGNOIR": "Peignoir",
  "PEINTURE": "Peinture",
  "PELLE_DE_JARDINAGE": "Pelle de jardinage",
  "PEPITES_DE_CHOCOLAT": "Pépites de chocolat",
  "PERCARBONATE_DE_SOUDE": "Percarbonate de soude",
  "PERFORATRICE": "Perforatrice",
  "PERSIL": "Persil",
  "PETITS_FRUITS_ET_BAIES": "Petits Fruits et Baies",
  "PHYSALIS": "Physalis",
  "PIEGE_A_INSECTES": "Piège à insectes",
  "PIERRE_D_ARGILE_DE_NETTOYAGE": "Pierre d'argile de nettoyage",
  "PILE": "Pile",
  "PILONS_DE_POULET": "Pilons de poulet",
  "PILULIER_ET_COUPE_COMPRIMES": "Pilulier et coupe-comprimés",
  "PIMENT_D_ESPELETTE": "Piment d'Espelette",
  "PIMENT_FRAIS": "Piment frais",
  "PINTADE": "Pintade",
  "PIZZA_FRAICHE": "Pizza fraîche",
  "PIZZA_SURGELEE": "Pizza surgelée",
  "PLAID": "Plaid",
  "PLANCHE_A_DECOUPER": "Planche à découper",
  "PLANTES": "Plantes",
  "PLANTE_D_EXTERIEUR": "Plante d’extérieur",
  "PLANTE_D_INTERIEUR": "Plante d’intérieur",
  "PLANTE_FLEURIE": "Plante fleurie",
  "PLANTE_SUCCULENTE": "Plante succulente",
  "PLANTE_VERTE": "Plante verte",
  "PLATS_CUISINES_FRAIS": "Plats cuisinés frais",
  "PLATS_CUISINES_SURGELES": "Plats cuisinés surgelés",
  "PLATS_ET_INGREDIENTS_SURGELES": "Plats et Ingrédients Surgelés",
  "PLAT_CUISINE_APPERTISE_EN_BOCAL": "Plat cuisiné appertisé en bocal",
  "PLAT_POUR_FOUR": "Plat pour four",
  "PNEU": "Pneu",
  "POCHE_DE_CHAUD_FROID": "Poche de chaud/froid",
  "POELE": "Poêle",
  "POELEE_WOK_ET_LEGUMES_FRAIS_DECOUPES": "Poêlée, wok et légumes frais découpés",
  "POIRE": "Poire",
  "POIREAU": "Poireau",
  "POIRE_FERMENTE": "Poiré",
  "POISSON": "Poisson",
  "POISSON_PANE": "Poisson pané",
  "POISSON_PANE_SURGELE": "Poisson pané surgelé",
  "POISSON_SURGELE": "Poisson surgelé",
  "POIS_CASSE": "Pois cassé",
  "POIS_CHICHE": "Pois chiche",
  "POIS_GOURMANDS_ET_FEVES": "Pois gourmands et fèves",
  "POIVRE": "Poivre",
  "POIVRON": "Poivron",
  "POLLEN": "Pollen",
  "POMME": "Pomme",
  "POMMES_DE_TERRE_SURGELEES": "Pommes de terre surgelées",
  "POMME_DE_TERRE": "Pomme de terre",
  "PORRIDGE": "Porridge",
  "PORTE_SAVON": "Porte-savon",
  "PORTO": "Porto",
  "POTIRON": "Potiron",
  "POT_DE_FLEURS": "Pot de fleurs",
  "POUDRE": "Poudre",
  "POUDRE_A_FLAN": "Poudre à flan",
  "POULET": "Poulet",
  "POULET_ENTIER": "Poulet entier",
  "POULPE": "Poulpe",
  "PREPARATION_PATISSIERE": "Préparation pâtissière",
  "PREPARATION_POUR_GATEAU": "Préparation pour gâteau",
  "PREPARATION_POUR_PAIN": "Préparation pour pain",
  "PRODUIT_COIFFANT": "Produit coiffant",
  "PRODUIT_D_ENTRETIEN": "Produit d'entretien",
  "PRODUIT_WC": "Produit WC",
  "PROTECTIONS_HYGIENIQUES": "Protections hygiéniques",
  "PROTECTION_AUDITIVE": "Protection auditive",
  "PROTECTION_SOLAIRE": "Protection solaire",
  "PROTEINES_VEGETALES_BRUTES": "Protéines végétales brutes",
  "PRUNE": "Prune",
  "PULL": "Pull",
  "PUREE_FLOCONS_DE_POMME_DE_TERRE": "Purée & Flocons de pomme de terre",
  "PUZZLE": "Puzzle",
  "PYJAMA": "Pyjama",
  "QUATRE_QUARTS": "Quatre-quarts",
  "QUETSCHE": "Quetsche",
  "QUICHE": "Quiche",
  "QUICHE_SURGELEE": "Quiche surgelée",
  "QUINOA": "Quinoa",
  "RACLETTE": "Raclette",
  "RADIS": "Radis",
  "RAISIN": "Raisin",
  "RASAGE_EPILATION": "Rasage & Épilation",
  "RASOIR": "Rasoir",
  "RAVIOLIS_FRAIS": "Raviolis frais",
  "REGLE": "Règle",
  "RHUBARBE": "Rhubarbe",
  "RHUM": "Rhum",
  "RHUMS": "Rhums",
  "RIDEAU": "Rideau",
  "RILLETTES": "Rillettes",
  "RIZ": "Riz",
  "RIZ_AU_LAIT": "Riz au lait",
  "ROBE": "Robe",
  "ROMARIN_FRAIS": "Romarin frais",
  "ROQUETTE": "Roquette",
  "ROSES": "Roses",
  "ROTI_DE_BOEUF": "Rôti de bœuf",
  "ROTI_DE_PORC": "Rôti de porc",
  "ROTI_DE_VEAU": "Rôti de veau",
  "ROUGE_A_LEVRES": "Rouge à lèvres",
  "RUBAN_ADHESIF": "Ruban adhésif",
  "RUMSTECK": "Rumsteck",
  "RUTABAGA": "Rutabaga",
  "SABLES": "Sablés",
  "SAC_A_DEJECTIONS": "Sac à déjections",
  "SAC_DE_CONGELATION": "Sac de congélation",
  "SAC_POUBELLE": "Sac poubelle",
  "SAINT_JACQUES": "Saint-Jacques",
  "SALADE": "Salade",
  "SALADE_COMPOSEE_FRAICHE": "Salade composée fraîche",
  "SALADE_DE_FRUITS": "Salade de fruits",
  "SALADE_REPAS": "Salade repas",
  "SALAMI": "Salami",
  "SANDWICH_FRAIS": "Sandwich frais",
  "SARDINE": "Sardine",
  "SAUCES_CONDIMENTS": "Sauces & Condiments",
  "SAUCE_PESTO": "Sauce pesto",
  "SAUCE_SALADE": "Sauce salade",
  "SAUCE_SOJA": "Sauce soja",
  "SAUCE_TOMATE": "Sauce tomate",
  "SAUCISSE": "Saucisse",
  "SAUCISSE_DE_STRASBOURG": "Saucisse de Strasbourg",
  "SAUCISSE_DE_TOULOUSE": "Saucisse de Toulouse",
  "SAUCISSE_VEGETALE": "Saucisse végétale",
  "SAUCISSON_SEC": "Saucisson sec",
  "SAUGE_FRAICHE": "Sauge fraîche",
  "SAUMON": "Saumon",
  "SAUTE_DE_PORC": "Sauté de porc",
  "SAUTE_D_AGNEAU": "Sauté d’agneau",
  "SAVON": "Savon",
  "SAVON_LIQUIDE_MAINS": "Savon liquide mains",
  "SAVON_NOIR_MENAGER": "Savon noir ménager",
  "SECATEUR": "Sécateur",
  "SEICHE": "Seiche",
  "SEITAN": "Seitan",
  "SEL": "Sel",
  "SEL_DE_DENEIGEMENT": "Sel de déneigement",
  "SEMOULE_AU_LAIT": "Semoule au lait",
  "SEMOULE_COUSCOUS": "Semoule & Couscous",
  "SERUM_CAPILLAIRE": "Sérum capillaire",
  "SERUM_VISAGE": "Sérum visage",
  "SERVIETTE_DE_BAIN": "Serviette de bain",
  "SERVIETTE_DE_TABLE": "Serviette de table",
  "SHAMPOING": "Shampoing",
  "SHAMPOING_SEC": "Shampoing sec",
  "SHAMPOING_SOLIDE": "Shampoing solide",
  "SHAMPOOING_ANIMAL": "Shampooing animal",
  "SHORT": "Short",
  "SIROP": "Sirop",
  "SIROP_D_AGAVE": "Sirop d’agave",
  "SIROP_D_ERABLE": "Sirop d’érable",
  "SKYR": "Skyr",
  "SMOOTHIE": "Smoothie",
  "SNACKS_SALES_APERITIF": "Snacks Salés & Apéritif",
  "SODA": "Soda",
  "SODAS_BOISSONS_SPECIALES": "Sodas & Boissons Spéciales",
  "SOIN_CAPILLAIRE": "Soin Capillaire",
  "SOIN_DES_PIEDS": "Soin des pieds",
  "SOIN_SANS_RINCAGE": "Soin sans rinçage",
  "SOIN_VISAGE_CORPS": "Soin Visage & Corps",
  "SOLE": "Sole",
  "SORBET": "Sorbet",
  "SOUPE": "Soupe",
  "SOURIS_D_AGNEAU": "Souris d’agneau",
  "SOUS_VETEMENT": "Sous-vêtement",
  "SPIRULINE": "Spiruline",
  "SPORT_PLEIN_AIR": "Sport & Plein air",
  "SPRAY_FROID": "Spray froid",
  "STEAK_DE_BOEUF": "Steak de bœuf",
  "STEAK_HACHE": "Steak haché",
  "STEAK_HACHE_SURGELE": "Steak haché surgelé",
  "STEAK_VEGETAL": "Steak végétal",
  "STYLO": "Stylo",
  "SUBSTITUTS_DE_POISSON": "Substituts de poisson",
  "SUBSTITUTS_DE_VIANDE": "Substituts de viande",
  "SUBSTITUT_DE_REPAS": "Substitut de repas",
  "SUCRE": "Sucre",
  "SUCRES_TARTINABLES": "Sucres & Tartinables",
  "SUCRE_GLACE": "Sucre glace",
  "SUCRE_ROUX": "Sucre roux",
  "SUPERFOOD": "Superfood",
  "SURIMI": "Surimi",
  "SURLIGNEUR": "Surligneur",
  "SWEAT": "Sweat",
  "TABLETTE_DE_CHOCOLAT": "Tablette de chocolat",
  "TABLETTE_LAVE_VAISSELLE": "Tablette lave-vaisselle",
  "TABOULE": "Taboulé",
  "TAIE_D_OREILLER": "Taie d’oreiller",
  "TAILLE_CRAYON": "Taille-crayon",
  "TAPENADE": "Tapenade",
  "TAPIS_DE_BAIN": "Tapis de bain",
  "TARAMA": "Tarama",
  "TARTE_SALEE_SURGELEE": "Tarte salée surgelée",
  "TASSE": "Tasse",
  "TEMPEH": "Tempeh",
  "TENSIOMETRE": "Tensiomètre",
  "TERREAU": "Terreau",
  "TERREAU_PLANTES_D_INTERIEUR": "Terreau plantes d’intérieur",
  "TERREAU_SEMIS_BOUTURAGE": "Terreau semis & bouturage",
  "TERREAU_UNIVERSEL": "Terreau universel",
  "TERRE_DE_SOMMIERES": "Terre de Sommières",
  "TERRINE": "Terrine",
  "TEST_DE_GROSSESSE": "Test de grossesse",
  "THE": "Thé",
  "THERMOMETRE_MEDICAL": "Thermomètre médical",
  "THE_GLACE": "Thé glacé",
  "THON": "Thon",
  "THYM_FRAIS": "Thym frais",
  "THYM_SEC": "Thym sec",
  "TIRE_TIQUES": "Tire-tiques",
  "TOFU": "Tofu",
  "TOMATE": "Tomate",
  "TOMATE_CERISE": "Tomate cerise",
  "TONIC": "Tonic",
  "TOPINAMBOUR": "Topinambour",
  "TORCHONS": "Torchons",
  "TORTELLINIS_FRAIS": "Tortellinis frais",
  "TORTILLA": "Tortilla",
  "TRAITEUR_FRAIS": "Traiteur Frais",
  "TRAVERS_DE_PORC": "Travers de porc",
  "TROTTINETTE": "Trottinette",
  "TROUSSE_DE_PREMIERS_SECOURS": "Trousse de premiers secours",
  "TROUSSE_DE_TOILETTE_ET_DE_VOYAGE": "Trousse de toilette et de voyage",
  "TROUSSE_SCOLAIRE": "Trousse scolaire",
  "TRUITE": "Truite",
  "TUBERCULES": "Tubercules",
  "TULIPES": "Tulipes",
  "TUYAU_D_ARROSAGE": "Tuyau d’arrosage",
  "TZATZIKI": "Tzatziki",
  "T_SHIRT": "T-shirt",
  "USTENSILE_DE_CUISINE": "Ustensile de cuisine",
  "VELO": "Vélo",
  "VERMOUTH": "Vermouth",
  "VERNIS_A_ONGLES": "Vernis à ongles",
  "VERRE": "Verre",
  "VESTE": "Veste",
  "VETEMENTS": "Vêtements",
  "VIANDE": "Viande",
  "VIANDE_A_BOUILLIR_BOEUF": "Viande à bouillir (bœuf)",
  "VIANDE_A_BRAISER_BOEUF": "Viande à braiser (bœuf)",
  "VIANDE_A_MIJOTER_VEAU": "Viande à mijoter (veau)",
  "VIANDE_HACHEE": "Viande hachée",
  "VIANDE_SURGELEE": "Viande surgelée",
  "VIN": "Vin",
  "VINAIGRE": "Vinaigre",
  "VINAIGRETTE": "Vinaigrette",
  "VINAIGRE_MENAGER": "Vinaigre ménager",
  "VINS": "Vins",
  "VINS_FORTIFIES_APERITIFS": "Vins fortifiés & apéritifs",
  "VIN_BLANC": "Vin blanc",
  "VIN_DOUX": "Vin doux",
  "VIN_EFFERVESCENT": "Vin effervescent",
  "VIN_ROSE": "Vin rosé",
  "VIN_ROUGE": "Vin rouge",
  "VIN_SANS_ALCOOL": "Vin sans alcool",
  "VIS": "Vis",
  "VODKA": "Vodka",
  "VODKAS": "Vodkas",
  "VOLAILLE": "Volaille",
  "WASABI": "Wasabi",
  "WHISKIES": "Whiskies",
  "WHISKY": "Whisky",
  "WRAP": "Wrap",
  "YAOURTS": "Yaourts",
  "YAOURT_AROMATISE": "Yaourt aromatisé",
  "YAOURT_A_BOIRE": "Yaourt à boire",
  "YAOURT_GREC": "Yaourt grec",
  "YAOURT_NATURE": "Yaourt nature",
  "YAOURT_VEGETAL": "Yaourt végétal"
}
